<app-chat-window
  *ngIf="isDev()"
  [isChatOpen]="(aiChatWindowService.isOpen$ | async) || false"
></app-chat-window>
<router-outlet></router-outlet>
